import { Box, Typography } from "@mui/material";
import { useStyles } from "./styles";

interface IOrganizationInfo {
  organizationName: string;
  organizationFederalTaxId: string;
}

const OrganizationInfo = ({
  organizationName,
  organizationFederalTaxId,
}: IOrganizationInfo) => {
  const classes = useStyles();

  const maskCNPJ = (cnpj: string): string => {
    cnpj = cnpj?.replace(/\D/g, "");

    cnpj = cnpj?.replace(/^(\d{2})(\d)/, "$1.$2");
    cnpj = cnpj?.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    cnpj = cnpj?.replace(/\.(\d{3})(\d)/, ".$1/$2");
    cnpj = cnpj?.replace(/(\d{4})(\d{2})$/, "$1-$2");

    return cnpj;
  };

  return (
    <Box className={classes.container}>
      <Typography className={classes.organization}>
        {organizationName}
      </Typography>
      <Typography className={classes.federalTaxId}>
        {maskCNPJ(organizationFederalTaxId)}
      </Typography>
    </Box>
  );
};

export default OrganizationInfo;
